import { reactive } from "vue";

const DEFAULT_DURATION_SECONDS = 3;

export const messageState = reactive({ queue: [] });

let nextId = 0;

function dismiss(id) {
	const index = messageState.queue.findIndex((item) => item.id === id);
	if (index !== -1) messageState.queue.splice(index, 1);
}

function push(type, content, duration = DEFAULT_DURATION_SECONDS) {
	const id = ++nextId;
	messageState.queue.push({
		id,
		type,
		content: String(content),
		timeout: duration === 0 ? -1 : duration * 1000
	});
	return () => dismiss(id);
}

/**
 * Drop-in replacement for the ant-design `message` API that the components call as
 * `this.$message.<type>(text, seconds)`. A duration of 0 keeps the message open; every call
 * returns a function that dismisses it. `MessageHost.vue` renders the queue one at a time.
 */
export const message = {
	success: (content, duration) => push("success", content, duration),
	error: (content, duration) => push("error", content, duration),
	warning: (content, duration) => push("warning", content, duration),
	info: (content, duration) => push("info", content, duration),
	loading: (content, duration) => push("loading", content, duration),
	dismiss
};

export default {
	install(app) {
		app.config.globalProperties.$message = message;
	}
};
